import React from 'react'
import { useDispatch } from 'react-redux'
import { requestPassword } from 'api/auth'
import { setNotification } from 'actions/status'
import { Grid, Typography, Button, Paper, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Email from 'components/Fields/Email'
import { FormProvider } from 'react-hook-form'
import useFormExpanded from 'hooks/useFormExpanded'
import LoginBackgroundImage from '../img/login-cul-de-sac.png'

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    height: '100vh',
    backgroundImage: `url(${LoginBackgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }
}))

const ForgotPassword = () => {
  const formMethods = useFormExpanded()
  const { handleSubmit } = formMethods
  const dispatch = useDispatch()
  const classes = useStyles()

  function handleReset({ email }) {
    requestPassword(email).then(({ data: { message } }) => {
      dispatch(setNotification('success', message))
    }).catch(({ data: { errors } }) => {
      dispatch(setNotification('error', errors.join(', ')))
    })
  }

  return (
    <Grid container justifyContent='center' alignItems='center' className={classes.root}>
      <Grid item xs={10} sm={6} md={6} lg={4}>
        <Box component={Paper} elevation={6} p={3} textAlign='center'>
          <Typography variant='h4'>Forgot your password?</Typography>
          <Typography variant='subtitle1'>No worries, we'll email you a new one!</Typography>
          <FormProvider { ...formMethods }>
            <form onSubmit={handleSubmit(handleReset)}>
              <Email fullWidth autoFocus margin='normal' />
              <Button size='large' fullWidth type='submit' color='primary' variant='contained'>send email</Button>
            </form>
          </FormProvider>
        </Box>
      </Grid>
    </Grid>
  )
}

export default ForgotPassword
